import { render } from "./RoleSettingsView.vue?vue&type=template&id=30c54816&scoped=true"
import script from "./RoleSettingsView.vue?vue&type=script&lang=js"
export * from "./RoleSettingsView.vue?vue&type=script&lang=js"

import "./RoleSettingsView.vue?vue&type=style&index=0&id=30c54816&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c54816"]])

export default __exports__